import AppConfig from "../helpers/AppConfig";
import BaseResponse from "../model/BaseResponse";
import axios from "axios";
import {StringUtils} from "../utils/StringUtils";

export default class BaseService {
    private static csrfToken: string = '';

    static getCsrfToken = async () => {
        if (!this.csrfToken) {
            const response = await axios.get('/getCsrfToken');
            this.csrfToken = response.data.csrfToken;
        }
        return this.csrfToken;
    }

    static generatePostRequest = async (data: any) => {
        return {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': await this.getCsrfToken()
            },
            body: StringUtils.stringify(data)
        }
    }

    static handleBaseResponse = async (response: any) => {
        if (!response.ok && response.status === 401) {
            window.location.href = AppConfig.PowFormUrl + '/dashboard/database';

            return null;
        }

        if (!response.ok) {
            return new BaseResponse(false, '');
        }

        let responseObject = await response.json();

        if (responseObject.processed !== undefined && !responseObject.processed) {
            return new BaseResponse(false, responseObject.message);
        }

        return new BaseResponse(true, '');
    }

    static handleErrorBaseResponse = (error: any) => {
        return new BaseResponse(false, error.message);
    }

    static handleBufferResponse = async (response: any) => {
        if (!response.ok && response.status === 401) {
            window.location.href = AppConfig.PowFormUrl + '/dashboard/database';

            return null;
        }

        if (!response.ok) {
            return new BaseResponse(false, '');
        }

        return response.blob().then((blob: Blob) => this.showInOtherTab(blob))
    }

    static showInOtherTab(blob: Blob) {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    static handleUrlResponse = async (response: any) => {
        if (!response.ok && response.status === 401) {
            window.location.href = AppConfig.PowFormUrl + '/dashboard/database';
            return null;
        }
        if (!response.ok) {
            return new BaseResponse(false, '');
        }
        let responseObject = await response.json();
        if (responseObject.processed !== undefined && !responseObject.processed) {
            return new BaseResponse(false, responseObject.message);
        }else if(responseObject.processed && responseObject.redirectUrl){
            window.open(responseObject.redirectUrl, '_blank');
            return new BaseResponse(true, '');
        }
        return new BaseResponse(false, '');
    }
}
